import React from 'react';

const contacts = [
  { name: 'Nahuel Figueroa', phone: '541141615158' },
  { name: 'Jorge Figueroa', phone: '541157135158' },
  { name: 'Adrián Castro', phone: '541157136770' },
];

const WhatsAppContact = () => {
  return (
<div
  style={{
    display: 'flex',
    justifyContent: 'center',
    gap: '10px',
    marginTop: '40px',
    padding: '20px',
    backgroundColor: '#f1f1f1',
  }}
>
  {contacts.map((contact, index) => (
    <a
      key={index}
      href={`https://wa.me/${contact.phone}?text=Hola%20${encodeURIComponent(
        contact.name
      )},%20quiero%20más%20info%20sobre%20los%20servicios%20de%20eventos`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#25D366',
        color: 'white',
        textDecoration: 'none',
        padding: '10px 15px',
        borderRadius: '30px',
        fontWeight: 'bold',
        fontSize: '14px',
        boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
        transition: 'transform 0.2s',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
      onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
    >
      <img
        src="https://cdn-icons-png.flaticon.com/512/124/124034.png"
        alt="WhatsApp"
        style={{ width: '20px', height: '20px', marginRight: '8px' }}
      />
      {contact.name}
    </a>
  ))}
</div>

  );
};

export default WhatsAppContact;

